module.exports = __webpack_public_path__ + "static/media/spider1.73f6a8ef.PNG";